import { render } from "./ActivityGame.vue?vue&type=template&id=105725a4&scoped=true&ts=true"
import script from "./ActivityGame.vue?vue&type=script&lang=ts"
export * from "./ActivityGame.vue?vue&type=script&lang=ts"

import "./ActivityGame.vue?vue&type=style&index=0&id=105725a4&scoped=true&lang=postcss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105725a4"]])

export default __exports__